import { ModuleWithProviders, NgModule } from '@angular/core';
import { ModalContainerComponent } from 'app/components/modal/modal.container.component';
import { ModalService } from 'app/services/modal.service';

@NgModule({
    exports: [
        ModalContainerComponent
    ],
    declarations: [
        ModalContainerComponent
    ]
})

export class ModalModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: ModalModule,
            providers: [ModalService]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/modal.module.ts